import axios from 'axios';
import authService from './authService';

const API_URL = '/api/best-deals/';

// Add a request interceptor to include the auth token
axios.interceptors.request.use(
  (config) => {
    const user = authService.getCurrentUser();
    if (user && user.accessToken) {
      config.headers.Authorization = 'Bearer ' + user.accessToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

class BestDealService {
  // Public endpoints
  getActiveDeals() {
    return axios.get(API_URL + 'public');
  }

  getDealById(id) {
    return axios.get(API_URL + `public/${id}`);
  }

  // Admin endpoints
  getAllDeals(page = 0, size = 10, sortBy = 'displayOrder', sortDir = 'asc') {
    return axios.get(API_URL + `admin?page=${page}&size=${size}&sortBy=${sortBy}&sortDir=${sortDir}`);
  }

  getDealByIdAdmin(id) {
    return axios.get(API_URL + `admin/${id}`);
  }

  createDeal(dealData) {
    return axios.post(API_URL + 'admin', dealData);
  }

  updateDeal(id, dealData) {
    return axios.put(API_URL + `admin/${id}`, dealData);
  }

  deleteDeal(id) {
    return axios.delete(API_URL + `admin/${id}`);
  }
}

export default new BestDealService();